import { JsonSchemaValidator } from "@common/json-schema-validator";

export const brandOverlayDataFile = {
  [JsonSchemaValidator.isFile]: true
};
